import { validAgencyTranslated } from './validAgency/validAgency'

export * from './formValidators.models'

export { requiredTranslated as required } from './required'

export { onlyNumberTranslated as onlyNumber } from './onlyNumber'

export {
  lowerOrEqualThanTranslated as lowerOrEqualThan,
} from './lowerOrEqualThan'

export { validEmailTranslated as validEmail } from './validEmail'

export { biggerThanZeroTranslated as biggerThanZero } from './biggerThanZero'

export { dateAboveTodayTranslated as dateAboveToday } from './dateAboveToday'

export { validDateTranslated as validDate } from './validDate'

export {
  validPhoneLengthTranslated as validPhoneLength,
} from './validPhoneLength'

export {
  validPhoneNumberTranslated as validPhoneNumber,
} from './validPhoneNumber'

export {
  validSwissPostalCodeTranslated as validSwissPostalCode,
} from './validSwissPostalCode'

export {
  validVehiclePlateTranslated as validVehiclePlate,
} from './validVehiclePlate'

export { validAgencyTranslated as validAgency } from './validAgency'
